export default "__VITE_ASSET__BwDaeqkj__"